import callApi from '@/utils/callApi';
import { memoize } from '@gamifiera/array-cache';

const getCustomerAttributeTypes = memoize(async function () {
  const res = await callApi('GET', '/v1/client/customer-attribute-types');

  if (res.status !== 200) {
    console.error('Could not load customer attribute types');
    return {};
  }

  let data = await res.json();

  return data.types;
}, 600);


export default getCustomerAttributeTypes;
